// import { useState, useEffect } from 'react';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
export const JWT_KEY = '__dex_web_token';
// export const STORAGE_KEY_NAME = '__pumpx_session_token';
export const getJwtToken = (): string | undefined => {
  try {
    const token = global.localStorage.getItem(JWT_KEY);
    return token ?? undefined;
  } catch {
    return undefined;
  }
};
export const clearToken = () => {
  try {
    global.localStorage.removeItem(JWT_KEY);
  } catch {}
};
type UseSessionResult = {
  isLogin: boolean;
  token?: string;
};
export const useSession = (): UseQueryResult<UseSessionResult> => {
  return useQuery({
    queryKey: ['user-session'],
    queryFn: async (): Promise<UseSessionResult> => {
      const token = getJwtToken();
      return {
        isLogin: !!token,
        token,
      };
    },
  });
};
// export const useLocalStorage = <T>(key: string, initialValue: T) => {
//   const [storedValue, setStoredValue] = useState<T>(initialValue);
//
//   useEffect(() => {
//     if (typeof window !== 'undefined') {
//       try {
//         const item = window.localStorage.getItem(key);
//         setStoredValue(item ? JSON.parse(item) : initialValue);
//       } catch (error) {
//         console.error(error);
//         setStoredValue(initialValue);
//       }
//     }
//   }, [key, initialValue]);
//
//   const setValue = (value: T | ((val: T) => T)) => {
//     if (typeof window !== 'undefined') {
//       try {
//         const valueToStore =
//           value instanceof Function ? value(storedValue) : value;
//         setStoredValue(valueToStore);
//         window.localStorage.setItem(key, JSON.stringify(valueToStore));
//       } catch (error) {
//         console.error(error);
//       }
//     }
//   };
//
//   return [storedValue, setValue] as const;
// };

export async function storeSession(args: { jwt: string }): Promise<void> {
  if (args.jwt) {
    // email login
    global.localStorage.setItem(JWT_KEY, args.jwt);
    return;
  } else {
    throw new Error('Invalid login');
  }
}
